import { render, staticRenderFns } from "./TestPrediction.vue?vue&type=template&id=cd026b34&scoped=true"
import script from "./TestPrediction.vue?vue&type=script&lang=js"
export * from "./TestPrediction.vue?vue&type=script&lang=js"
import style0 from "./TestPrediction.vue?vue&type=style&index=0&id=cd026b34&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd026b34",
  null
  
)

export default component.exports